'use client';

import { createContext, useContext } from 'react';

import { AppStateService, appStateService } from './app.state.service';

/**
 * Carries the request's own state instance through a server render. In the
 * browser nothing provides it and consumers fall back to the singleton.
 */
export const AppStateContext = createContext<AppStateService | null>(null);

export const useAppStateService = (): AppStateService =>
  useContext(AppStateContext) ?? appStateService;
